
import Vue from 'vue'
import Component from 'vue-class-component'
import { contactSave } from '@/api'
import { Toast } from 'vant'
import { Mixins } from 'vue-property-decorator'
import MechanismHeader from '@/components/MechanismHeader.vue'
import { phoneValidator } from '@/common'
@Component({
  components: { MechanismHeader },
})
export default class IndexView extends Vue {
  active = 1
  userName = ''
  userPhone = ''
  companyName = ''
  introduceList = [
    {
      imageName: 'online',
      title: '业务线上化',
      describe:
        '线上化交易平台，支持上架多种基金产品，供机构投资者多方位选型产品，为机构投资者提供投研服务，全面赋能机构投资者。',
    },
    {
      imageName: 'systemPlatform',
      title: '系统平台化',
      describe: '与公司现有多套系统进行交互对接，实现全流程电子化的理财产品交易。',
    },
    {
      imageName: 'diversification',
      title: '功能多样化',
      describe:
        '提供便捷的线上+线下结合的方式开户。提升交易效率，解决单笔交易效率低、单笔限额等问题。投研方面提供专业化的资源和工具帮助，便于快速进行投资标的筛选和确定。',
    },
  ]
  transactList = [
    {
      id: 1,
      title: '01. 上传信息 免费开户',
      tag: '开户帮助',
      stepIcon: 'stepOne',
    },
    {
      id: 2,
      title: '02. 登录交易端交易',
      tag: '交易指南',
      stepIcon: 'stepTwo',
    },
    {
      title: '03. 购买基金  走上机构理财之路',
      stepIcon: 'stepThree',
    },
  ]
  jumpToHelp(type: string) {
    this.$router.push({ path: '/helpMechanism', query: { catalogueType: type ? type : '' } })
  }
  // 提交文件接口
  async submitContactSave() {
    debugger
    if (!this.userName.trim()) {
      return Toast('请您填写联系人姓名')
    } else if (!phoneValidator(this.userPhone)) {
      return this.userPhone ? Toast('请您填写正确的手机号或座机号') : Toast('请您填写联系方式')
    } else if (!this.companyName.trim()) {
      return Toast('请您填写企业名称')
    }
    const params = {
      name: this.userName,
      phone: this.userPhone,
      enterpriseName: this.companyName,
    }
    try {
      const res: any = await contactSave(params)
      if (res.code === 0) {
        Toast('感谢您对华源证券的关注，我们的工作人员会尽快联系您！')
        this.userName = ''
        this.userPhone = ''
        this.companyName = ''
      } else {
        Toast(res.msg)
      }
    } catch (error) {
      Toast('网络繁忙，请您稍后重试！')
    }
  }
}
